import crudFactory from "../crudFactory.ts";

const MODEL = "dnd/shipments";

const COMMON_CRUD_APIs = crudFactory(MODEL);

export default { ...COMMON_CRUD_APIs };
